/* スクロールに応じて要素を「フワッ」と表示。(IntersectionObserverを使った実装) */
// 少し遅延させて表示させる要素も制御。
const intersectionObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      // 'js-in-view-delay' クラスを持つ要素の場合、0.4秒遅延させる
      if (entry.target.classList.contains("js-in-view-delay")) {
        setTimeout(() => {
          entry.target.classList.add("is-in-view");
        }, 400); // 0.4秒遅延
      } else {
        // 遅延させずに 'is-in-view' クラスを追加
        entry.target.classList.add("is-in-view");
      }
    } else {
      // 要素が視界から外れたら 'is-in-view' クラスを削除
      // entry.target.classList.remove("is-in-view");
    }
  });
});

// 遅延なしでフワッと表示させたい要素
const inViewItems = document.querySelectorAll(".js-in-view");
inViewItems.forEach(function (inViewItem) {
  intersectionObserver.observe(inViewItem);
});

// 0.4秒遅延してフワッと表示させたい要素
const inViewItemsDelay = document.querySelectorAll(".js-in-view-delay");
inViewItemsDelay.forEach(function (inViewItem) {
  intersectionObserver.observe(inViewItem);
});


/* ==================================================================== */
/* 画面左上に文字を固定し、セクションが切り替われば文字も切り替える */
document.addEventListener('DOMContentLoaded', function() {
  const look1Section = document.querySelector('.look1');
  const look2Section = document.querySelector('.look2');
  const look1SideImg = document.querySelector('.look1 .side-img');
  const look2SideImg = document.querySelector('.look2 .side-img');

  // スクロールイベントのリスナーを追加
  window.addEventListener('scroll', function() {
    const headerHeight = 100; // ヘッダーの高さをピクセル単位で指定
    const scrollPosition = (window.pageYOffset || document.documentElement.scrollTop) + headerHeight;
      const look1SectionTop = look1Section.offsetTop;
      const look2SectionTop = look2Section.offsetTop;

      // 画面の幅に応じて固定する位置を変更
      const fixedTop = window.innerWidth >= 768 ? '120px' : '90px'; 
      const fixedLeft = window.innerWidth >= 768 ? '50px' : '12px';

      // look1セクション内にいるかのチェック
      if (scrollPosition >= look1SectionTop && scrollPosition < look2SectionTop) {
          look1SideImg.style.position = 'fixed';
          look1SideImg.style.top = fixedTop;
          look1SideImg.style.left = fixedLeft;
          look2SideImg.style.position = '';
          look2SideImg.style.top = '';
          look2SideImg.style.left = '';
      }
      // look2セクション内にいるかのチェック
      else if (scrollPosition >= look2SectionTop) {
          look2SideImg.style.position = 'fixed';
          look2SideImg.style.top = fixedTop;
          look2SideImg.style.left = fixedLeft;
          look1SideImg.style.position = '';
          look1SideImg.style.top = '';
          look1SideImg.style.left = '';
      } else {
          // スクロールがlook1セクションの上にある場合は、固定を解除
          look1SideImg.style.position = '';
          look1SideImg.style.top = '';
          look1SideImg.style.left = '';
          look2SideImg.style.position = '';
          look2SideImg.style.top = '';
          look2SideImg.style.left = '';
      }
  });
});
